// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e4a99323","845":"5557599a"}[chunkId] + ".chunk.js";
};